import themes from '../themes.config'

export default function ({ $config }, inject) {
  const themeName = $config.theme
  const themeConfig = themes[themeName]
  inject('uiTheme', themeConfig)
}
